import { DomainEventType } from '../enums';
import { CreatorScoreModel } from '../loop/creator-score.model';

/** Score dimension targeted by an execution instruction. */
export type ScoreType = keyof CreatorScoreModel;

/** Contract for a deterministic score update derived from a domain event. */
export interface ScoreUpdateInstruction {
  creatorId: string;
  scoreType: ScoreType;
  /** Conceptual delta — magnitude defined by future execution policy, not here. */
  delta: number;
  sourceEvent: DomainEventType;
}

/** Batch of score updates produced by the event processing pipeline. */
export interface ScoreUpdateInput {
  creatorId: string;
  instructions: ScoreUpdateInstruction[];
}
